module.exports = __webpack_public_path__ + "static/media/vue.2c89899b.png";